<template>
  <ca-async-content-wrapper
    :on-fetch="getRegistrationWorker"
    :on-fetch-success="setWorker">
    <ca-row vertical-offset="4">
      <ca-col>
        <ca-heading text="Dados básicos" size="medium"></ca-heading>
      </ca-col>
    </ca-row>
    <ca-row-divider margin-bottom="medium"></ca-row-divider>
    <ca-row>
      <ca-col
        v-for="(info, index) in registrationWorkerBasicInfo"
        :key="index"
        size="3"
        class="ca-u-min-margin-top">
        <ca-field :label="info.label">
          {{ info.value }}
        </ca-field>
      </ca-col>
    </ca-row>

    <div v-if="worker.foreigner">
      <ca-row vertical-offset="4">
        <ca-col>
          <ca-heading text="Nacionalidade" size="medium"></ca-heading>
        </ca-col>
      </ca-row>
      <ca-row-divider margin-bottom="medium"></ca-row-divider>
      <ca-row>
        <ca-col
          v-for="(info, index) in registrationWorkerNationality"
          :key="index"
          size="3"
          class="ca-u-min-margin-top">
          <ca-field
            :label="info.label">
            {{ info.value }}
          </ca-field>
        </ca-col>
      </ca-row>
    </div>

    <ca-row vertical-offset="4">
      <ca-col>
        <ca-heading text="Documentos" size="medium"></ca-heading>
      </ca-col>
    </ca-row>
    <ca-row-divider margin-bottom="medium"></ca-row-divider>
    <ca-row>
      <ca-col
        v-for="(info, index) in registrationWorkerDocuments"
        :key="index"
        size="3"
        class="ca-u-min-margin-top">
        <ca-field
          :label="info.label">
          {{ info.value }}
        </ca-field>
      </ca-col>
    </ca-row>

    <ca-row vertical-offset="4">
      <ca-col>
        <ca-heading text="Endereço" size="medium"></ca-heading>
      </ca-col>
    </ca-row>
    <ca-row-divider margin-bottom="medium"></ca-row-divider>
    <ca-row>
      <ca-col
        v-for="(info, index) in registrationWorkerAddress"
        :key="index"
        size="3"
        class="ca-u-min-margin-top">
        <ca-field
          :label="info.label">
          {{ info.value }}
        </ca-field>
      </ca-col>
    </ca-row>

    <ca-row vertical-offset="4">
      <ca-col>
        <ca-heading text="Deficiência" size="medium"></ca-heading>
      </ca-col>
    </ca-row>
    <ca-row-divider margin-bottom="medium"></ca-row-divider>
    <ca-row>
      <ca-col
        v-for="(info, index) in registrationWorkerHandicapped"
        :key="index"
        size="3"
        class="ca-u-min-margin-top">
        <ca-field
          :label="info.label">
          {{ info.value }}
        </ca-field>
      </ca-col>
    </ca-row>

    <ca-row vertical-offset="4">
      <ca-col>
        <ca-heading text="Dependentes" size="medium"></ca-heading>
      </ca-col>
    </ca-row>
    <ca-row-divider margin-bottom="medium"></ca-row-divider>
    <worker-dependents-table></worker-dependents-table>

    <ca-row vertical-offset="4">
      <ca-col>
        <ca-heading text="Anexos" size="medium"></ca-heading>
      </ca-col>
    </ca-row>
    <ca-row-divider margin-bottom="medium"></ca-row-divider>
    <worker-attachments-table :worker-id="workerId"></worker-attachments-table>

    <ca-row vertical-offset="4">
      <ca-col>
        <ca-heading text="Adicionais" size="medium"></ca-heading>
      </ca-col>
    </ca-row>
    <ca-row-divider></ca-row-divider>
    <ca-row>
      <ca-col
        v-for="(info, index) in registrationWorkerAdditionalInfo"
        :key="index"
        size="4"
        class="ca-u-min-margin-top">
        <ca-field
          :label="info.label">
          {{ info.value }}
        </ca-field>
      </ca-col>
    </ca-row>
  </ca-async-content-wrapper>
</template>

<script>
import { openPdf } from 'packages/common/utils/file';
import { getErrorMessageFromResponse } from 'packages/common/utils';
import WorkerDependentsTable from 'accountant/worker/src/modules/workers/sub-pages/registration/components/worker-dependents-tab/WorkerDependentsTable';
import WorkerAttachmentsTable from 'accountant/worker/src/modules/workers/sub-pages/registration/components/worker-attachments-tab/WorkerAttachmentsTable';
import {
  getRegistrationWorker,
  getRegistrationWorkerPdf,
  getWorkerPicture,
} from 'accountant/worker/src/modules/workers/sub-pages/registration/workerRegistrationService';
import {
  mountRegistrationWorkerBasicInfo,
  mountRegistrationWorkerDocuments,
  mountRegistrationWorkerHandicappedInfo,
  mountRegistrationWorkerAddress,
  mountWorkerNationality,
  mountRegistrationWorkerAdditionalInfo,
} from './workerPersonalDataService';
import store from '../../../../../../store/index';

export default {
  name: 'WorkerPersonalDataView',
  components: {
    WorkerDependentsTable,
    WorkerAttachmentsTable,
  },
  props: {
    workerName: String,
  },
  data() {
    return {
      worker: {},
      workerPicture: null,
      isFormValid: null,
      registrationWorkerBasicInfo: {},
      registrationWorkerDocuments: {},
      registrationWorkerNationality: {},
      registrationWorkerAddress: {},
      registrationWorkerHandicapped: {},
      registrationWorkerAdditionalInfo: {},
    };
  },
  computed: {
    workerBasicInfo() {
      return store.state.worker.basicInfo;
    },
    workerId() {
      return this.workerBasicInfo?.id;
    },
  },
  created() {
    this.setWorkerPicture();
  },
  methods: {
    getRegistrationWorker() {
      return getRegistrationWorker(this.workerId);
    },
    async setWorker(response) {
      this.worker = response;
      this.registrationWorkerBasicInfo = mountRegistrationWorkerBasicInfo(this.worker);
      this.registrationWorkerDocuments = mountRegistrationWorkerDocuments(this.worker);
      this.registrationWorkerAddress = mountRegistrationWorkerAddress(this.worker);
      this.registrationWorkerHandicapped = mountRegistrationWorkerHandicappedInfo(this.worker);
      this.registrationWorkerAdditionalInfo = mountRegistrationWorkerAdditionalInfo(this.worker);

      if (this.worker.foreigner) {
        this.registrationWorkerNationality = await mountWorkerNationality(this.worker);
      }
    },
    async setWorkerPicture() {
      const response = await getWorkerPicture(this.workerId);

      const reader = new FileReader();
      reader.onload = () => {
        this.workerPicture = reader.result;
      };
      reader.readAsDataURL(response);
    },
    onEdit() {
      this.$refs.rollover.close();
      this.$router.push({ name: 'EditWorkerRegistration', params: { id: this.workerId } });
    },
    onPrint() {
      return getRegistrationWorkerPdf(this.workerId);
    },
    onPrintSuccess(response) {
      openPdf(response);
    },
    onPrintError(error) {
      this.$toaster.error(getErrorMessageFromResponse(error));
    },
  },
};
</script>
